import React from 'react';
import LocationTemplate from './LocationTemplate';

const AngierPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Angier"
      stateName="North Carolina"
      countyName="Harnett"
      zipCodes={["27501"]}
      latitude={35.5068}
      longitude={-78.7397}
      population={5091}
      historicalFact="Named after Major Jonathan Milton Angier, a railroad superintendent."
      nearbyTowns={[
        "Fuquay-Varina, NC",
        "Holly Springs, NC",
        "Apex, NC",
        "Lillington, NC",
        "Coats, NC",
        "Erwin, NC",
        "Dunn, NC",
        "Benson, NC"
      ]}
    />
  );
};

export default AngierPage;